import { Button } from '@bambi/component-library/src/components/Button/Button';
import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';

import { TilledLogo } from 'src/common/primitives/logos/TilledLogo';

import { useCanLaunchMerchantApplication } from '../helpers/useCanLaunchMerchantApplication';
import { useConnectMerchantAccount } from '../helpers/useConnectMerchantAccount';

export function StartTilledMerchantApplication() {
  const { loading, trigger: handleCreateMerchantAccount } =
    useConnectMerchantAccount();

  const canLaunchApplication = useCanLaunchMerchantApplication();

  return (
    <>
      <div
        data-testid="start-tilled-merchant-application"
        className="flex flex-grow flex-row items-center gap-2"
      >
        <TilledLogo />
        <div>
          Create your merchant account with our payment processing partner
          Tilled.
        </div>
      </div>
      <div>
        <SimpleTooltip
          trigger={
            <div className="flex">
              <Button
                dataTestId="tilled-connect-button"
                loading={loading}
                onClick={handleCreateMerchantAccount}
                disabled={!canLaunchApplication}
              >
                Connect
              </Button>
            </div>
          }
          content={
            !canLaunchApplication
              ? 'Only Owners can perform this function'
              : null
          }
        />
      </div>
    </>
  );
}
